"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var snippet_1 = require("./snippet");

var api_1 = require("./api");

var sdkOptionsDefaults = {
  devMode: false,
  scriptURL: snippet_1.defaultScriptURL
};
var opts = Object.assign({}, sdkOptionsDefaults);

var isLoaded = function isLoaded() {
  return window.__ls;
};

var getApiMethod = function getApiMethod(name) {
  if (!isLoaded()) {
    throw new Error("LiveSession is not loaded. Call init() before calling other API functions");
  }

  var objectAPI = api_1.default;

  if (!objectAPI.hasOwnProperty(name)) {
    throw new Error("method \"".concat(name, "\" doesn't exist"));
  }

  if (opts.devMode) {
    var msg = "Skipping method: ".concat(name, ", devMode enabled");
    console.warn(msg);
    return function () {
      return msg;
    };
  }

  return objectAPI[name];
};

var safeCall = function safeCall(name) {
  return function (args) {
    var apiMethod = getApiMethod(name);

    if (apiMethod) {
      return apiMethod(args);
    }
  };
};

var safeCallManyArgs = function safeCallManyArgs(name) {
  return function () {
    var apiMethod = getApiMethod(name);

    if (apiMethod) {
      return apiMethod.apply(void 0, arguments);
    }
  };
};

var _init = function _init(trackID, options) {
  var sdkOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : sdkOptionsDefaults;
  opts = Object.assign(Object.assign({}, sdkOptionsDefaults), sdkOptions);

  if (isLoaded()) {
    console.warn("LiveSession already inited (skipping init() call)");
    return;
  }

  if (!trackID) {
    throw new Error("trackID is required");
  }

  snippet_1.default(window, document, "script", sdkOptions.scriptURL);
  return api_1.default.init(trackID, options);
};

exports.default = {
  init: _init,
  getSessionURL: safeCall("getSessionURL"),
  identify: safeCall("identify"),
  invalidateSession: safeCall("invalidateSession"),
  newPageView: safeCall("newPageView"),
  setOptions: safeCall("setOptions"),
  setCustomParams: safeCall("setCustomParams"),
  off: safeCall("off"),
  optOut: safeCall("optOut"),
  debug: safeCall("debug"),
  track: function track(eventName, properties) {
    safeCallManyArgs("track")(eventName, properties);
  },
  log: function log(logLevel) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    safeCallManyArgs("log").apply(void 0, [logLevel].concat(args));
  }
};